import { render, staticRenderFns } from "./SurveyQuickEditForm.vue?vue&type=template&id=1c7e5f1c&lang=pug"
import script from "./SurveyQuickEditForm.vue?vue&type=script&lang=js"
export * from "./SurveyQuickEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DobOrAgeFormGroup: require('/home/docker/code/frontend/components/DobOrAgeFormGroup.vue').default,Location: require('/home/docker/code/frontend/components/Location.vue').default})
